import {required, minLength, maxLength} from 'react-admin'

export const validateName = [required(), minLength(1), maxLength(150)];